import { QueryClient } from '@tanstack/react-query';

import { DEFAULT_MESSAGE_GROUPS_BY_SEGMENT } from '@telialt/messages/src/constants';
import { CommonModel } from '@telialt/models/src/CommonModel';
import { axiosForAnonymousHudson } from '@telialt/utils/src/axios/axiosForAnonymousHudson';

import { API, MESSAGES_QUERY_KEY } from './constants';
import { MessagesType } from './model';

export const apiGetMessages = async (groups: string[]) => {
    const { data } = await axiosForAnonymousHudson.get<MessagesType>(API.URL_MESSAGES, {
        params: {
            groups: groups?.length > 0 ? groups.join(',') : undefined,
            v: process.env.GIT_HASH,
        },
    });

    return data;
};

export const prefetchMessages = (
    queryClient: QueryClient,
    segment: CommonModel.Segment,
    requestedGroups?: string[],
    customMessages?: Record<string, string>,
) => {
    const defaultGroups = DEFAULT_MESSAGE_GROUPS_BY_SEGMENT[segment];
    const groups = requestedGroups || defaultGroups;

    return queryClient.fetchQuery({
        queryKey: [MESSAGES_QUERY_KEY, groups],
        queryFn: async () => Object.assign(await apiGetMessages(groups), customMessages),
    });
};
